import React from 'react';
import { Badge } from 'react-bootstrap';
import './CountBadge.css';

const CountBadge = ({ 
  count = 0, 
  variant = 'danger', 
  size = 'sm',
  maxCount = 99,
  showZero = false,
  className = '',
  ...props 
}) => {
  // Ensure count is a valid number
  const validCount = typeof count === 'number' && !isNaN(count) ? count : 0;
  
  // Don't show badge if count is 0 and showZero is false
  if (validCount === 0 && !showZero) {
    return null;
  }

  // Format count display
  const displayCount = validCount > maxCount ? `${maxCount}+` : validCount.toString();

  // Determine badge variant based on count
  const getVariant = () => {
    if (variant === 'auto') {
      if (validCount === 0) return 'secondary';
      if (validCount <= 5) return 'success';
      if (validCount <= 20) return 'warning';
      return 'danger';
    }
    return variant;
  };

  return (
    <Badge 
      bg={getVariant()} 
      className={`count-badge count-badge-${size} ${className}`}
      {...props}
    >
      {displayCount}
    </Badge>
  );
};

export default CountBadge;
